<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">企业经营数据服务平台</div>
        <div
          class="desc"
        >企业经营数据服务平台在以下方面为企业提供了便捷与服务，包括药品进销存的管理、协议返利的自动计算、订单的申请和审核、统计分析等，为企业提供了一个符合企业需求的经营服务平台。</div>
        <div>
          <p class="service">服务</p>
          <p class="fun">企业经营数据服务平台的功能模块有：</p>
          <img src="./images/img.png" alt />
        </div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product5.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from "components/product-banner";
export default {
  components: {
    productBanner
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    .title
      line-height 70px
      color #0160B7
      font-size 30px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    margin-top 8%
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    .item
      line-height 58px
      width 32%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240, 246, 255, 1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
@media screen and (min-width: 1300px) and (max-width: 1550px)
  .service
    margin-top 3% !important
@media screen and (max-width: 1300px)
  .ins
    justify-content space-between
    .title
      line-height 1 !important
    .service
      margin-top 0 !important
</style>



// WEBPACK FOOTER //
// src/pages/qyjy/qyjy.vue